<template>
  <div class="content">
    <transition name="el-zoom-in-top">
      <div class="top" v-show="isshwo">
        <div class="contentlist">
          <div style="margin-bottom: 40px">
            <p class="onetitle">天禄云枢·四库全书数据库</p>
            <p class="twotitle">
              <!-- 这是一个囊括90%以上古籍资源拥有2000万本书籍的古籍资源库 -->
              共收录{{ bookNum }}部古籍
            </p>
          </div>
          <div class="searchbox">
            <div class="searchlist">
              <el-tooltip
                placement="top"
                effect="dark"
                :open-delay="1000"
                transition="el-fade-in-linear"
              >
                <div slot="content" style="font-size: 14px">
                  支持多个关键词输入，且结果精确匹配展示。并支持繁简异体关联、关联字、关联词以及超大字符集等检索词。
                </div>
                <div
                  :class="
                    newParam.searchType == 0
                      ? 'searchitem searchactive'
                      : 'searchitem'
                  "
                  @click="newParam.searchType = '0'"
                >
                  一般检索
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                effect="dark"
                :open-delay="1000"
                transition="el-fade-in-linear"
              >
                <div slot="content" style="color: #bbb; font-size: 14px">
                  支持多维度，例如：作者、书名、专名词等，同时支持逻辑（且/或/非）组合检索。
                </div>
                <div
                  :class="
                    newParam.searchType == 1
                      ? 'searchitem searchactive'
                      : 'searchitem'
                  "
                  @click="
                    newParam.searchType = '1';
                    showmenu = true;
                  "
                >
                  逻辑检索
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                effect="dark"
                :open-delay="1000"
                transition="el-fade-in-linear"
              >
                <div slot="content" style="color: #bbb; font-size: 14px">
                  支持设置关键词之间的字距关系，且支持逻辑（且/或/非）组合检索。
                </div>
                <div
                  :class="
                    newParam.searchType == 2
                      ? 'searchitem searchactive'
                      : 'searchitem'
                  "
                  @click="
                    newParam.searchType = '2';
                    showmenu = true;
                  "
                >
                  范围检索
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                effect="dark"
                :open-delay="1000"
                transition="el-fade-in-linear"
              >
                <div slot="content" style="color: #bbb; font-size: 14px">
                  支持关键词输入，且结果精确匹配展示。并支持繁简异体关联、关联字、关联词等检索词。
                </div>
                <div
                  :class="
                    newParam.searchType == 3
                      ? 'searchitem searchactive'
                      : 'searchitem'
                  "
                  @click="
                    newParam.searchType = '3';
                    showmenu = true;
                  "
                >
                  书目检索
                </div>
              </el-tooltip>
            </div>
            <!-- <el-input
          placeholder="请输入内容"
          v-model="input3"
          class="input-with-select"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input> -->

            <div class="yibanBox">
              <el-autocomplete
                :placeholder="
                  newParam.searchType == 0
                    ? '请输入关键词进行检索 多个关键词之间用空格隔开'
                    : '请输入关键词进行检索'
                "
                v-model="newParam.keyword"
                class="input-select"
                @click.stop.native
                @keyup.enter.native="clickSearch(true)"
                style="margin-bottom: 0"
                type="search"
                :fetch-suggestions="
                  (queryString, cb) => {
                    getStorages(queryString, cb, 'keyword');
                  }
                "
              >
                <!-- <el-select
              v-model="newParam.searchType"
              slot="prepend"
              placeholder="請選擇"
              style="width: 120px"
            >
              <el-option label="一般检索" value="0"></el-option>
              <el-option label="逻辑检索" value="1"></el-option>
              <el-option label="范围检索" value="2"></el-option>
              <el-option label="书目检索" value="3"></el-option>
            </el-select> -->
                <!-- <span>{{ searchtext }}</span> -->
                <el-select
                  v-if="newParam.searchType == '1'"
                  v-model="newParam.textType"
                  style="width: 80px; margin-left: 20px"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="正文" value="1"></el-option>
                  <el-option label="书名" value="5"></el-option>
                  <el-option label="作者" value="4"></el-option>
                  <!--                    <el-option label="注释" value="2"></el-option>-->
                  <el-option label="专名词" value="3"></el-option>


                  <!-- <el-option label="篇内容" value="7"></el-option> -->
                  <el-option label="书名词" value="8"></el-option>
                  <el-option label="地名词" value="9"></el-option>
                </el-select>
                <!-- <img slot="append" class="after" src="/static/icon/data.png" /> -->
                <el-button
                  slot="append"
                  type="primary"
                  :class="{ 'submit-btn': true, 'zoomed ': isZoomed }"
                  :icon="loading ? 'el-icon-loading' : ''"
                  round
                  @click.stop="clickSearch(true)"
                >
                  <img
                    v-if="!loading"
                    style="height: 20px; width: auto"
                    src="/static/search.png"
                    alt=""
                  />
                </el-button>
              </el-autocomplete>
              <div class="fanweibutton">
                <el-button
                  type="primary"
                  class="submit-btn"
                  v-if="
                    newParam.searchType != '0' && newParam.searchType != '3'
                  "
                  round
                  @click.stop="isFanwei = !isFanwei"
                >
                  范围选择
                </el-button>
              </div>
            </div>
            <div
              v-if="
                showmenu && newParam.searchType != 0 && newParam.searchType != 3
              "
              style="
                background: #F6F2E9;
                border-radius:0 0 4px 4px;
                height: 180px;
                width: 94%;
                padding: 0 20px;
                margin-left: 3%;
              "
            >
              <div v-if="!isFanwei">
                <template v-if="newParam.searchType == '1'">
                  <el-autocomplete
                    v-for="(item, index) in advancedQuery"
                    :key="index + 'ad'"
                    placeholder="请输入关键词进行检索"
                    @click.stop.native
                    v-model="item.keyword"
                    @keyup.enter.native="clickSearch(true)"
                    class="input-select"
                    :fetch-suggestions="
                      (queryString, cb) => {
                        getStorages(queryString, cb, 'advanced' + index);
                      }
                    "
                    style="margin-top: 15px"
                  >
                    <el-select
                      v-model="item.type"
                      style="width: 120px; margin-right: 20px"
                      slot="prepend"
                      placeholder="请选择"
                    >
                      <el-option label="OR" value="or"></el-option>
                      <el-option label="AND" value="and"></el-option>
                      <el-option label="NOT" value="not"></el-option>
                    </el-select>
                    <el-select
                      v-model="item.textType"
                      style="width: 80px"
                      slot="prepend"
                      placeholder="请选择"
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option label="正文" value="1"></el-option>
                      <el-option label="书名" value="5"></el-option>
                      <el-option label="作者" value="4"></el-option>
                      <!--                    <el-option label="注释" value="2"></el-option>-->
                      <el-option label="专名词" value="3"></el-option>


                      <!-- <el-option label="篇内容" value="7"></el-option> -->
                      <el-option label="书名词" value="8"></el-option>
                      <el-option label="地名词" value="9"></el-option>
                    </el-select>
                    <!-- <img
                slot="append"
                class="after"
                @click.stop="advancedQuery.splice(index, 1)"
                src="/static/icon/delete.png"
              /> -->
                  </el-autocomplete>
                </template>
                <template v-if="newParam.searchType == '2'">
                  <el-autocomplete
                    v-for="(item, index) in neardQuery"
                    :key="index + 'ne'"
                    placeholder="请输入关键词进行检索"
                    :fetch-suggestions="
                      (queryString, cb) => {
                        getStorages(queryString, cb, 'neard' + index);
                      }
                    "
                    @click.stop.native
                    @keyup.enter.native="clickSearch(true)"
                    v-model="item.keyword"
                    class="input-select input-select-label inputNumber"
                    style="padding-right: 0px; margin-top: 15px"
                  >
                    <div slot="prepend">
                      NEAR字距
                      <el-select
                        v-model="item.type"
                        v-if="item.type"
                        style="width: 120px; padding: 0 20px"
                        slot="prepend"
                        placeholder="请选择"
                      >
                        <el-option label="OR" value="or"></el-option>
                        <el-option label="AND" value="and"></el-option>
                        <el-option label="NOT" value="not"></el-option>
                      </el-select>
                      <el-input-number
                        class="onlyNumber"
                        v-model="item.spacing"
                        style="width: 100px"
                        :min="1"
                        :max="30"
                        controls-position="right"
                      >
                      </el-input-number>
                    </div>
                  </el-autocomplete>
                </template>
                <el-button
                  type="text"
                  icon="el-icon-refresh-right"
                  @click="isZoomed = !isZoomed"
                  :class="{ 'zoom-in': isZoomed, 'zoom-out': !isZoomed }"
                  v-if="
                    newParam.searchType == '1' || newParam.searchType == '2'
                  "
                  @click.stop="clearsearch"
                  style="margin-top: 15px;color: #E9B63E"
                >重置</el-button
                >
              </div>
              <div class="fanweibox" v-else>
                <div class="fanweilist" style="width: 33%">
                  <el-checkbox-group
                    class="padding-left left-width"
                    v-model="searchFilter.categoryNames"
                    width="33%"
                  >
                    <el-checkbox
                      v-for="item in catalist"
                      :label="item.showName"
                      :key="item.showName"
                      :value="item.showName"
                      style="width: 100%; margin-right: 0; height: 26px"
                    >
                      {{ item.showName }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>

                <!--                <div class="fanweilist">
                                  <el-checkbox-group
                                    class="padding-left left-width"
                                    v-model="searchFilter.bookReadingListIds"
                                  >
                                    <el-checkbox
                                      v-for="item in readinglist"
                                      :label="item.id"
                                      :key="item.id"
                                      :value="item.id"
                                      style="width: 100%; margin-right: 0; height: 26px"
                                    >
                                      {{ item.showName }}
                                    </el-checkbox>
                                  </el-checkbox-group>
                                </div>-->
                <div class="fanweilist" style="width: 66%">
                  <el-checkbox-group
                    class="padding-left left-width wrap-box"
                    v-model="searchFilter.dynastyNames"

                  >
                    <el-checkbox
                      v-for="item in dynastylist"
                      :label="item.label"
                      :key="item.value"
                      :value="item.value"
                      @click.stop.native
                      style="width: 33%; height: 26px"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <!--                  <el-tree
                                      :empty-text="emptyText"
                                      ref="treeList"
                                      v-show="dynastylist"
                                      :data="dynastylist"
                                      :check-on-click-node="true"
                                      :expand-on-click-node="false"
                                      @check="setSearchFilter()"
                                      node-key="wholeLabel"
                                      show-checkbox
                                      style="background-color: none"
                                    >
                                      <span class="span-ellipsis" slot-scope="{ node, data }">
                                        <span>{{ node.label }}</span>
                                      </span>
                                    </el-tree>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div class="bottom">
        <div class="bottomcon">
          <div class="bottomimg" @click="isshwo = !isshwo">
            <img class="tobottom" src="/static/homenew/bottom.jpg" alt="" />
          </div>
          <div class="botomtitle">
            <router-link :to="{ path: '/booklist' }">推荐书单</router-link>
          </div>
          <div class="botomsetitle">
            <p>
              RECOMMENDED BOOK LIST<router-link :to="{ path: '/booklist' }"
            ><span class="more">
              更多<i class="el-icon-right"></i></span
            ></router-link>
            </p>
          </div>


          <div class="booklist" v-show="!isshwo">
            <div
              class="booklistcon"
              v-for="(item, index) in systemReadListparam.rows"
              :key="index"
              @click="jamp(item.listId, item.bookCount)"
            >
              <div class="booklistconse">
                <div class="imgcontent">

                </div>
                <div class="textcontent">
                  <div class="texttitle">{{ item.listName }}</div>
                  <div class="setitle">本书单共“{{ item.bookCount }}”本书</div>
                  <div class="textline"></div>
                  <div class="bcontent">
                    <!-- [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也\
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也\
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也 -->
                    {{ item.description }}
                  </div>
<!--                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>-->
                </div>
              </div>
            </div>
            <!-- <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/1.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/1.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/2.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/3.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/1.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/1.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="booklistcon">
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/1.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">xxxxx书单1</div>
                  <div class="setitle">本书单共“8”本书</div>
                  <div class="textline"></div>
                  <div class="content">
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                    1.霍州李白先生管语诸生日:
                    [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
                  </div>
                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </transition>
    <el-dialog
      title="系统维护通知"
      :visible.sync="dialogVisible"
      width="600px"
      :show-close="false"
    >
      <div style="line-height: 1.8;">
        <p>尊敬的用户：</p>
        <p style="margin: 15px 0;">
          由于机房电力维护，期间平台将暂停访问。现将相关事宜通知如下：
        </p>

        <div style="margin: 20px 0;">
          <p>1.维护时间：2025年12月20日0:00至 2025年12月22日12:00。</p>
          <p>2.影响范围：维护期间，网站将暂停服务，所有页面将无法访问，相关业务也将暂时无法办理。</p>
          <p>3.恢复服务：我们会尽量在计划时间内完成维护。如提前或延迟完成，将另行通知。</p>
        </div>

        <p>此次维护给您带来不便，我们深表歉意。感谢您的理解与支持！</p>

        <div style="margin-top: 30px; text-align: right;">
          <p><strong>天禄云枢古籍数据库</strong></p>
          <p>2025年12月19日</p>
        </div>
      </div>

      <span slot="footer">
        <el-button type="primary" @click="dialogVisible = false">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLatestList,
  readinglistBySearch,
  newGetCategoryNode,
  newGetWriterList,
  getReadListNew,
  getDynastyListNew,
  getBookCount,
  dkLogin
} from "@/api/api"
import 'element-ui/lib/theme-chalk/base.css'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import Vue from 'vue'
import eventBus from "@/utils/eventBus.js"

Vue.component(CollapseTransition.name, CollapseTransition)
export default {
  name: "Home",
  data () {
    return {
      dialogVisible:false,
      isZoomed: false,
      isHovered: -1,
      isshwo: true,
      isFanwei: false,
      searchFilter: {
        categoryNames: [],
        dynastyNames: [],
        bookReadingListIds: [],
        // categoryIds: []
      },
      showmenu: false,
      // allShow: false,
      // showHide: true,
      isLogin: false,
      isVip: false,//是否vip
      gridData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      centerDialogVisible: true,
      historyList: {
        'home': '首页', 'login': '登录注册', 'search': '搜索(全局)', 'search-in': '搜索(书内)', 'detail': '书籍详情',
        'read': '阅读', 'note': '笔记', 'jiaoji': '校记', 'mark': '书签', 'feedback': '反馈', 'word-count': '字数统计',
        'project': '儒藏工程', 'about': '关于我们', 'pay': '充值中心', 'my-read': '我的阅读', 'my-note': '我的笔记', 'my-favor': '我的收藏', 'my-order': '我的订单',
        'analyze-cat': '数据分析-部类', 'analyze-book': '数据分析-书名', 'analyze-dynasty': '数据分析-朝代', 'export': '导出检索结果',
        '1': '閲讀', '2': '搜索'
      },
      systemReadListparam: {
        pageNum: 1,
        pageSize: 8,
        rows: [],
        total: 0
      },
      newParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        keyword: "",
        type: 0,
        searchType: "0",
        //sort: "0", //排序 0 正序 1倒序
        //sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
        // categoryIds: "",
        //writerIds: "",
        // dynastyIds: "",
        categoryNames: [],
        dynastyNames: [],
        //writerInitials: "",
        bookIds: "",
        advaList: [],
        hitCountType: 0,
        isInnerSearch: 0,//0 全局 1书内检索
        searchAccuracyType: 1,
        isOnlyPermit: 1,//是否全库 0 全局 1仅授权
        textType: "0",
        dynastylist: []
      },
      loading: false,
      advancedQuery: [
        {
          type: "and",
          textType: "0",
          keyword: "",
        },
        {
          type: "and",
          textType: "0",
          keyword: "",
        },
      ],
      neardQuery: [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ],
      readinglist: [],//书单
      writerList: [],
      catalist: [],//分类
      bookNum: 0,
    }
  },
  computed: {
    searchtext: function () {
      let re = this.newParam.searchType == 0 ? '一般检索' : (this.newParam.searchType == 1 ? '逻辑检索' : (this.newParam.searchType == 2 ? '范围检索' : this.newParam.searchType == 3 ? '书目检索' : '一般检索')); return re
    }

  },

  created () {
    this.dialogVisible=false
    const code = new URLSearchParams(window.location.search).get('code');
    console.log(code)
    if(code && (!localStorage.getItem("token"))){
      // 稻壳登录
      dkLogin({ code: code }).then(
        res => {
          console.log('++++++++++++dkLogin res:', res)
          console.log(4)
          if (res.code === 200) {
            localStorage.setItem("token", "Bearer " + res.token)
            eventBus.$emit("getUserInfo")
            // eventBus.$emit("openBindMobile")
            eventBus.$emit("doChangeloginVisible", false)
            this.isVip = localStorage.getItem('isVip') == 'null' ? false : localStorage.getItem('isVip')
            this.isLogin = localStorage.getItem("token") ? true : false
            this.$message.success("登録成功")
            location.reload()
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    }

  },
  mounted () {
    window.addEventListener('wheel', this.handleScroll)
    this.isVip = localStorage.getItem('isVip') == 'null' ? false : localStorage.getItem('isVip')
    this.isLogin = localStorage.getItem("token") ? true : false
    // this.getLatests()
    // document.addEventListener('click', this.handleClickOutside)
    // this.getWriterList('')
    this.getCategoryNodeData({})
    this.readinglistBySearchF({})
    this.getDynastyListNew()
    this.getBookCount()


    // const element = document.querySelector('.searchitem')

    // this.$refs.searchitem.addEventListener('mouseenter', function () {
    //   console.log('xxx')
    //   this.$refs.classList.add('searchitemactive') // 鼠标进入时添加类
    // })

    // this.$refs.searchitem.addEventListener('mouseleave', function () {
    //   this.$refs.classList.remove('searchitemactive') // 鼠标离开时移除类
    // })
    this.getSystemReadList()
  },
  methods: {
    jamp (id, count) {
      if (count == 0) {
        return this.$message({
          message: '该书本数量为0',
          type: 'warning'
        })
      }


      this.$router.push({ name: 'GoBooks', params: { listid: id } })
    },
    getBookCount () {
      getBookCount().then(
        (data) => {
          if (data.code == 200
          ) {
            this.bookNum = data.data
          }
        })

    },
    setSearchFilter () {
      // const { dynastyIds, writerIds } = this.searchFilter
      // this.isSearchFilter =
      //   (dynastyIds && dynastyIds.length) ||
      //   (writerIds && writerIds.length) ||
      let ids = this.$refs.treeList.getCheckedKeys(true)
      this.searchFilter.dynastyNames = ids
      console.log(ids, 'let ids')
      // this.$forceUpdate()
      // this.clickSearch()
    },
    getDynastyListNew () {
      let que = { keyword: this.dynasty }
      getDynastyListNew(que).then((data) => {
        if (!data.data) {
          this.emptyText = "暫無數據"
        }

        this.dynastylist = data.data
        // console.log(this.dynastylist, 'this.dynastylist')

      })

    },
    getSystemReadList () {
      let { pageNum, pageSize } = this.systemReadListparam
      getReadListNew({ pageNum, pageSize, isPublic: 1 }).then(d => {
        console.log(d)
        this.systemReadListparam.rows = d.rows
        this.systemReadListparam.total = d.total
      })
    },

    handleScroll (event) {
      const { deltaY } = event
      if (deltaY > 0) {
        // 向下滚动，翻到下一页
        this.isshwo = false
      } else if (deltaY < 0) {
        // 向上滚动，翻到上一页
        // this.currentPage--
        this.isshwo = true
      }
    },
    toggleSize () {
      this.isSmall = !this.isSmall // 切换大小状态
      // 如果你想要在动画完成后添加其他逻辑，可以使用 Vue 的 nextTick 或 CSS 的 animationend 事件
      if (this.isSmall) {
        setTimeout(() => {
          this.isSmall = false // 恢复到原始大小，这里只是为了演示，实际上不需要这样做，因为CSS已经处理了过渡效果。
        }, 500) // 与CSS动画时间匹配
      }
    },


    getWriterList (key) {

      newGetWriterList({ keyword: key }).then(
        (d) => {
          this.writerList = d.data
        },

      )
    },
    getCategoryNodeData (que) {
      this.emptyText = "查詢中..."

      newGetCategoryNode(que).then((data) => {

        this.catalist = data.data
        // console.log(this.catalist, 'data')

      })
    },
    readinglistBySearchF (query) {

      readinglistBySearch(query).then(
        (d) => {
          this.readinglist = [...d.userSearchRangeVoList, ...d.systemSearchRangeVoList]
          // console.log(this.readinglist, 'this.readinglist')
        },

      )

    },
    //点击空白处关闭弹窗
    handleClickOutside (event) {
      // 判断点击的区域是否在弹窗外部
      // console.log(event)
      if (this.showmenu && !this.$refs.popop.contains(event.target)) {
        this.showmenu = false
      }
    },
    clearsearch () {

      // this.description = "請在上方輸入關鍵詞檢索，或者在左側選擇文獻閲讀";
      // this.isSearching = false;
      // this.searchResult = {};
      // this.newParam = {
      //   pageSize: 10,
      //   pageNum: 1,
      //   total: 0,
      //   keyword: "",
      //   type: 0,
      //   searchType: "0",
      //   sort: "0", //排序 0 正序 1倒序
      //   sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
      //   categoryIds: "",
      //   writerIds: "",
      //   dynastyIds: "",
      //   writerInitials: "",
      //   bookIds: "",
      //   advaList: [],
      //   hitCountType: 0,
      // };
      this.newParam.keyword = ''
      this.advancedQuery = [
        {
          type: "and",
          keyword: "",
          textType: "0",
        },
        {
          type: "and",
          keyword: "",
          textType: "0",
        },
      ]
      this.neardQuery = [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ]
      // }
      // this.getCategoryNodeData();
    },
    clickSearch () {
      let str = JSON.stringify({ textType: this.newParam.textType, searchType: this.newParam.searchType, keyword: this.newParam.keyword, advancedQuery: this.advancedQuery, nearQuery: this.neardQuery, searchFilter: this.searchFilter })
      // this.$bus.$emit("acceptparam", str)
      // this.$router.push({ name: 'Search' })

      // this.$router.push({ path: '/search', query: { operStr: str } })
      // 在Vue组件中
      this.$router.push({ name: 'Search', params: { operStr: str } })

    },
    getStorages (queryString, cb, key) {
      // console.log(queryString, key, 'key')
      // console.log(this.historyList[key], this.historyList[key])
      if ((!this.historyList[key]) || (this.historyList[key].length == 0)) {
        cb([])
        return
      }
      let results = this.historyList[key]
      let res = []
      results.forEach((item) => {
        res.push({ value: item })
      })
      cb(res)
    },
    getLatestData () {
      // this.getLatests()
      this.centerDialogVisible = true
    },
    historyTo (row) {
      console.log(row)
      let url = ''
      if (row.operStr) {
        let item = JSON.parse(row.operStr)
        if (row.operType == 1 || row.operType == 'read') {

          url = this.$router.resolve(`/viewer?bookId=${item.bookId}&bookName=${item.bookName}&catalogId=${item.catalogId}&juanNum=${item.juanNum}`)

        } else if (row.operType == 2 || row.operType == 'search' || row.operType == 'search-in') {
          if (item.isInnerSearch == '1' || row.operType == 'search-in') {//书内检索
            url = this.$router.resolve(`/viewer?bookId=${item.bookId}&keyword=${item.keyword}&operStr=${row.operStr}`)
          } else {
            url = this.$router.resolve(`/search?keyword=${item.keyword}&operStr=${row.operStr}`)
          }

        } else if (row.operType == 'detail') {
          url = this.$router.resolve(`/bookDetail?id=${item.bookId}`)

        }

      } else {
        switch (row.operType) {
          case 'search':
            url = this.$router.resolve("/search")
            break

        }
      }

      window.open(url.href)
    },
    pageChange (val) {
      this.pageNum = val
      // this.getLatests()
    },
    closepop () {
      this.$refs.popover.doClose()
    },
    getLatests () {
      getLatestList({ pageNum: this.pageNum, pageSize: this.pageSize }).then((d) => {
        // console.log(d, 'dfsfs')
        if (d.code == 200) {
          let temprows = d.rows
          // temprows.forEach((ele) => {
          //   let operstrobj = ele.operStr && JSON.parse(ele.operStr)
          //   let keywordstr = ''
          //   if (ele.operStr && (ele.operType == 'search' || ele.operType == 'search-in' || ele.operType == 2)) {
          //     console.log(operstrobj, 'operstrobj')
          //     keywordstr = (operstrobj.searchType == '0') ? '一般檢索 ' + operstrobj.keyword : (operstrobj.searchType == '1') ? '進階檢索 ' + operstrobj.keyword : (operstrobj.searchType == '2') ? 'Near檢索 ' + operstrobj.keyword : ''
          //     if (operstrobj.advaList) {
          //       operstrobj.advaList.forEach((e) => {
          //         keywordstr += `、${e.type ? '(' + e.type + ')' : ''}${e.keyword}${e.spacing ? '(' + e.spacing + ')' : ''}`
          //       })
          //     }

          //   }
          //   ele.typestr = keywordstr
          //   ele.operstrobj = operstrobj
          // })
          this.gridData = temprows
          this.total = d.total
        }
      })
    },
    getout () {
      localStorage.removeItem("token")
      localStorage.removeItem("isVip")
      localStorage.removeItem("userinfo")
      this.$router.replace({
        path: "/"
      })
      this.isLogin = false
    },
    toPath (path) {
      this.$router.push({
        path: path
      })
    },
    toSearch (path) {
      this.$router.push({
        path: path
      }).catch(err => {
        console.log('报错')
      })
    },
    toggleSize () {
      this.isZoomed = !this.isZoomed
    }
  },
  beforeDestroy () {
    window.removeEventListener('wheel', this.handleScroll)
  },


}
</script>

<style lang="less" scoped>
@primary-color: #f4f0e8;
@first-color: #2c7e8d;
@secont-color: #666666;
@PingFang-SC-Medium: PingFang-SC-Medium;
@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;

// /deep/.perclass .el-tooltip__popper {
//   background: rgba(44, 126, 141, 0.4);
//   border: 1px solid red !important;
//   color: red !important;
// }
// /deep/.perclass > .el-tooltip__popper.is-light {
//   background: rgba(44, 126, 141, 0.4) !important;
//   border: 1px solid red !important;
//   color: red !important;
// }
// /deep/.procls {
//   border: 1px solid red;
// }
/*/deep/.el-select-dropdown__wrap{
  max-height:500px !important;
}
/deep/.el-select-dropdown__item{
 height: 25px;
  line-height: 25px;
}*/


/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #E9B63E;
}
/deep/ .el-checkbox__label{
  color: #2B2B2B;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #E9B63E;
  border-color: #E9B63E;
}
/deep/.el-checkbox__input .is-focus .el-checkbox__inner,
/deep/.el-checkbox__inner:hover {
  border-color: #E9B63E;
}
/deep/.el-tooltip__popper.is-light {
  background: rgba(44, 126, 141, 0.4);
  border: none !important;
}
// /deep/.procls.el-tooltip__popper {
//   border: 1px solid red !important;
// }
/deep/.el-input.is-active .el-input__inner,
/deep/.el-input__inner:focus {
  border-color: #E9B63E;
}
.zoom-in {
  animation: zoomIn 0.5s ease forwards;
}
/deep/.el-tree-node__content {
  font-size: 14px;
}

.zoom-out {
  animation: zoomOut 0.5s ease forwards;
}

@keyframes zoomIn {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes zoomOut {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
.onetitle {
  font-family: STSongti-SC, STSongti-SC;
  font-weight: 900;
  font-size: 32px;
  color: #36240C;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  margin: 0;
  padding: 0;
}
.totop {
  animation: mymove 2s infinite;
}
.tobottom {
  img {
    width: 27px;
    height: 28px;
  }
  position: absolute;
  animation: mymovetwo 2s infinite;
}
@keyframes mymove {
  from {
    bottom: 0px;
    opacity: 100;
  }
  to {
    bottom: 5px;
    opacity: 0;
  }
}
@keyframes mymovetwo {
  from {
    top: 0px;
    opacity: 0;
  }
  to {
    top: 5px;
    opacity: 100;
  }
}

.twotitle {
  font-family: STSongti-SC, STSongti-SC;
  font-weight: 400;
  font-size: 14px;
  color: #65553E;
  letter-spacing: 0;
  text-align: center;
  line-height: 30px;
  font-weight: 500;
}
.yibanBox {
  display: flex;
  .fanweibutton {
    .el-button--primary {
      width: auto;
      background: #795636;
      border-color: #795636;
      margin-left: 10px;
      border-radius: 4px;
      padding: 0 5px;
      transition: transform 0.3s ease;
    }
  }
}
.yibanBox:hover {
  /deep/.el-button--primary {
    background: #795636;
    border-color: #795636;
  }
}
.fanweibox {
  width: 100%;
  height: 100%;
  /* overflow-y: auto;
   overflow-x: hidden;*/
  display: flex;
  //justify-content: space-around;
  padding: 20px;
}
.fanweilist {
  //width: 33.3%;
  .wrap-box{
    display: flex;
    flex-wrap: wrap;
  }
}
.contentlist {
  width: 720px;
  margin: 0 auto;
  margin-top: 13vh;
}
.searchbox {
  width: 720px;
  // height: 152;
  background: #EDE4D3;
  border-radius: 8px;
  // border: 1px solid rgba(214, 207, 189, 0.2);
  padding: 20px 100px 40px;
  position: relative;
  .tipBox{
    width: 480px;
    position: absolute;
    padding: 5px;
    left: 740px;
    top:0;
    border-radius: 5px;
    background-color: rgb(254, 240, 240);
    //color: rgb(245, 108, 108);
    border-color: rgb(253, 226, 226);
    .tipName{
      font-size: 12px;
      font-weight: 400;
    }
    .tipMain{
      font-size: 10px;
      line-height: 20px;
    }
  }
}
.searchlist {
  display: flex;
  justify-content: left;
  margin-top: 10px;
  margin-bottom: 10px;
  .searchitem {
    width: 100px;
    height: 32px;
    margin-right: 20px;
    font-family: @PingFangSC-Regular;
    // font-size: 12px;
    // color: @secont-color;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #795636;
    // font-weight: 400;
  }
  .searchitem:hover {
    border-bottom: 2px solid @first-color;

    background: #795636;
    opacity: 0.6;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 4px;

    font-family: PingFang-SC-Bold;
    color: #FFFFFF;
    // line-height: 32px;
    font-weight: 700;
    position: relative;
    z-index: 9;
  }
  .searchitem:hover::after {
    content: ""; /* 伪元素必须有content属性 */
    position: absolute; /* 绝对定位 */
    bottom: -6px; /* 向下偏移，与长方形底部对齐 */
    left: 28%; /* 水平居中 */
    width: 2; /* 三角形宽度为0 */
    height: 0; /* 三角形高度为0 */
    border-left: 20px solid transparent; /* 左边框透明 */
    border-right: 20px solid transparent; /* 右边框透明 */
    border-top: 30px solid #795636; /* 上边框为三角形颜色，大小决定三角形大小 */
    z-index: -9;
  }
  .searchactive {
    border-bottom: 2px solid @first-color;
    background: #795636;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    color: #FFFFFF;
    // line-height: 32px;
    font-weight: 700;
    position: relative;
    z-index: 9;
  }

  .searchactive::after {
    content: ""; /* 伪元素必须有content属性 */
    position: absolute; /* 绝对定位 */
    bottom: -6px; /* 向下偏移，与长方形底部对齐 */
    left: 28%; /* 水平居中 */
    width: 2; /* 三角形宽度为0 */
    height: 0; /* 三角形高度为0 */
    border-left: 20px solid transparent; /* 左边框透明 */
    border-right: 20px solid transparent; /* 右边框透明 */
    border-top: 30px solid #795636; /* 上边框为三角形颜色，大小决定三角形大小 */
    z-index: -9;
  }
}
/deep/.el-input-group__prepend{
  background-color: #fff;
}
.inputNumber /deep/.el-input-group__prepend{
  padding: 0 0 0 20px;
}
.inputNumber .onlyNumber /deep/.el-input__inner{
  border-right: none;
  border-top:none;
  border-bottom: none;
  border-radius: 0;
}
// @import url(../assets/iconfont.css);
/deep/.el-input-group__append button.el-button,
.el-input-group__append div.el-select .el-input__inner,
.el-input-group__append div.el-select:hover .el-input__inner,
.el-input-group__prepend button.el-button,
.el-input-group__prepend div.el-select .el-input__inner,
.el-input-group__prepend div.el-select:hover .el-input__inner {
  background-color: #795636;
}

// /deep/.el-input-group {
//   margin-bottom: 10px;
// }
/deep/.el-input-number.is-controls-right .el-input__inner {
  padding-left: 10px;
}
/deep/.el-autocomplete {
  width: 100%;
}
.checkboxstyle {
  margin-left: 20px;
}
/*/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #3366cc;
}*/
.xinghao {
  // color: #3366cc;
  color: #e60012;
}
/deep/.el-dropdown-menu__item {
  line-height: 20px;
  padding: 0 10px;
}
/deep/.el-popover__title {
  text-align: center;
}
/deep/.el-button.is-round {
  border-radius: 0 4px 4px 0;
  width: 60px;
  height: 40px;
  padding: 0;
  // margin-top: 0.5px;
  position: relative;
  top: 1px;
}
.poptit {
  display: flex;
  justify-content: space-between;
  .popimg {
    width: 12px;
    height: 12px;
    // float: right;
    cursor: pointer;
  }
  .poptitle {
    font-size: 16px;
    font-weight: 700;
  }
}

// /deep/.el-button {
//   cursor: pointer;
// }
img {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  // background-color: #1c3d85;
  //background-color: #f4f0e8;

  //background-size: cover;
  // padding: 0 80px;

  .top {
    width: 100%;
    height: 70vh;
    background: url("/static/home/bankNew1.jpg") no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-between;
  }
  .bottom {
    width: 100%;
    //height: 20vh;
    background-color: #f4f0e8;
    padding: 6vh 0;

    .bottomcon {
      width: 90%;
      margin: 0 auto;

      .bottomimg {
        cursor: pointer;
        width: 27px;
        height: 38px;
        position: relative;
        margin: 0 auto 15px;
      }
      .botomtitle {
        font-family: PingFang-SC-Bold;
        font-size: 24px;
        color: #36240C;
        letter-spacing: 0;
        text-align: center;
        line-height: 24px;
        font-weight: 400;
        margin-bottom: 10px;
        a {
          color: #36240C;
        }
      }
      .botomsetitle {
        p {
          font-family: PingFang-SC-Regular;
          font-size: 14px;
          color: #746A5E;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          //font-weight: 400;
          margin-bottom: 15px;
          position: relative;
          // display: inline-block;
        }

        .more {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #746A5E;
          // line-height: -40px;
          font-weight: 400;
          position: absolute;
          right: 0px;
          bottom: 0px;
          cursor: pointer;
          display: flex;
          align-items: center;
          transition: display 0.5s ease;

          img {
            margin-left: 6px;
            width: 18px;
            height: 18px;
            display: none;
            transition: display 0.5s ease;
          }
        }
        .more:hover {
          img {
            display: block;
          }
        }
      }
      .botomline {
        width: 100%;
        margin: 0 auto;
        height: 1px;
        background-color: #d6cfbd;
      }
      .booklist {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        z-index: 1000;
        .booklistcon {
          cursor: pointer;
          margin: 20px 25px;
          width: 376px;
          height: 190px;
          //padding-top: 5px;
          //background: #fff;
          border-radius: 4px;
          .booklistconse {
            transition: border 0.5s ease;
            width: 100%;
            height: 100%;
            //background: rgba(255, 255, 255, 0.6);
            border-radius: 4px;
            padding: 12px;
            display: flex;
            align-items: top;
            position: relative;
            .playimg {
              width: 16px;
              height: 16px;
              position: absolute;
              right: 18px;
              top: 18px;
            }
            .imgcontent {
              width: 120px;
              height: 176px;
              margin-right: 10px;
              transition: transform 0.5s ease;
              background: url("/static/shudan.png") no-repeat;
              background-size: 120px 130px;
              margin-top:20px;
            }
            .textline {
              width: 100%;
              height: 1px;
              background: #e5e5e5;
              margin: 5px 0;
            }
            .textcontent {
              flex: 1;
            }
            .texttitle {
              font-family: PingFang-SC-Bold;
              font-size: 16px;
              color: #573E0D;
              letter-spacing: 0;
              line-height: 1.5;
              font-weight: 700;
              padding-right: 23px;
            }
            .setitle {
              font-family: PingFang-SC-Regular;
              font-size: 14px;
              color: #666666;
              letter-spacing: 0;
              line-height: 1.5;
              font-weight: 400;
            }
            .bcontent {
              width: 100%;
              // height: 100%;
              height: 105px;
              font-family: PingFang-SC-Regular;
              font-size: 13px;
              color: #666666;
              letter-spacing: 0;
              line-height: 1.6;
              font-weight: 400;
              text-align: justify;
              div {
                overflow: hidden;
              }

              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5; /* 限制行数为5 */
              overflow: hidden;

              //   overflow: hidden;
              //   overflow-wrap: break-word;
              //   word-break: break-all; /* 对于非英文字符 */
              // }
            }
            .content {
              font-family: PingFang-SC-Regular;
              font-size: 12px;
              color: #666666;
              letter-spacing: 0;
              line-height: 1.5;
              font-weight: 400;
              text-align: justify;
            }
          }
        }
        .booklistcon:hover {
          .imgcontent {
            //transform: scale(1.1);
          }
          .playimg {
            width: 17px;
            height: 17px;
            box-shadow: 0 2px 4px 0 rgba(209, 203, 189, 0.4);
          }
          .booklistconse {
            background: #F6F1E9;
            //border: 0.5px solid rgba(44, 126, 141, 1);
            box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
            // border-radius: 4px;
            transition: border 0.3s linear;
          }
        }
      }
    }
  }

  .nav {
    // width: 150px;
    display: flex;
    // flex-direction: column;
    .navitem {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .zhanwei {
      width: 116px;
    }

    .el-dropdown {
      margin-bottom: 30px;
      .buttonImg {
        width: 29px;
        height: 29px;
      }
    }

    margin-bottom: 130px;
  }
  .logobox {
    height: calc(~"100% - 60px");
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo {
    // height: 100%;
    flex-direction: column;
    // display: flex;
    // .ceshi {
    //   color: #fff;
    // }

    img {
      // width: 695px;
      width: 90%;
      height: auto;
    }
    .banquanbox {
      height: 60px;
      // position: fixed;
      // bottom: 0;
    }
    .banquan {
      display: block;
      width: 100%;
      height: 20px;
      display: flex;
      // margin-top: 30px;
      margin-bottom: 10px;
      // justify-content: space-between;
      // align-items: center;
      li {
        width: 33.3%;
        height: 20px;
        display: block;

        font-size: 14px;
        color: #e5e5e5;
        text-align: center;
        font-weight: 700;
        a {
          color: #e5e5e5;
          font-weight: 700;
        }
      }
    }
    .banquan li:not(:last-child) {
      border-right: 1px solid #e5e5e5;
    }
    .tuijian {
      text-align: center;
      font-size: 12px;
      color: #e5e5e5;
      font-weight: 700;
      padding: 0;
      margin: 0;
      margin-bottom: 16px;
    }
  }

  .title {
    writing-mode: vertical-rl;
    word-break: normal;
    // white-space: pre-wrap;

    margin-top: 80px;
    // width: 23px;
    font-size: 18px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #ffffff;
    line-height: 1.5;
    letter-spacing: 2px;
    p {
      margin: 0;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue